module.exports = __webpack_public_path__ + "static/media/harry-potter-skull.c9854d9c.svg";